(($) => {
  const wrapCards = () => {
    $('.scroll-image-section-mobile').each(function () {
      $(this)
        .find('h2.card-heading')
        .each(function () {
          const $h2 = $(this);
          const $p = $h2.next('p');
          if ($p.length && !$h2.parent().hasClass('card-wrapper')) { 
            const $wrapper = $('<div class="card-wrapper"></div>');
            $h2.before($wrapper);
            $wrapper.append($h2).append($p);
          }
        });
    });
  };

  // Run on page load if width <= 576
  if ($(window).width() <= 576) {
    wrapCards();
  }

  // Optional: Re-run on window resize
  $(window).on('resize', function () {
    if ($(window).width() <= 576) {
      wrapCards();
    }
  });
})(jQuery);
